import { BaseView, Filters, DataReq } from './view';
import stateColors from './state-colors';
import { isArray } from 'util';
import { Package } from '@/models/package';

export default class IView implements BaseView {
  public Name = 'package';

  public get Headers() {
    return [
      {
        name: 'id',
        text: "ID",
        value: "id",
        sortable: false,
      },
      // package_group_id: number;
      {
        name: 'code',
        text: "Code",
        value: "code",
        sortable: false,
      },
      {
        name: 'account_code',
        text: "Account Code",
        value: "account_code",
        sortable: false,
      },
      {
        name: 'title',
        text: "Title",
        align: 'left',
        value: "title",
        sortable: false,
      },
      {
        name: 'title-icon',
        text: "Title",
        type: "title-icon",
        // datasources: ['invoiceitem', 'package', 'deliveryitem'],
        align: 'left',
        value: "title",
        calc: (item: any, header: any) => item.title || (item.package ? item.package.title : ''),
        sortable: false,
      },
      {
        name: 'description',
        text: "Description",
        align: 'left',
        value: "description",
        sortable: false,
      },
      {
        name: 'category',
        text: "Category",
        value: "category",
        sortable: false,
      },
      {
        name: 'currency',
        text: "Currency",
        value: "currency",
        sortable: false,
      },
      {
        name: 'long_description',
        text: "Long Description",
        value: "long_description",
        sortable: false,
      },

      {
        name: 'is_plan',
        text: 'Is Plan',
        value: 'is_plan',
        sortable: false
      },
      {
        name: 'allow_multiple',
        text: 'Allow Multiple',
        value: 'allow_multiple',
        sortable: false
      },
      {
        name: 'interval',
        text: 'Interval',
        type: 'friendly_interval',
        value: 'interval',
        sortable: false
      },
      {
        type: "percentage",
        name: 'discount_rate',
        text: 'Discount Rate',
        value: 'discount_rate',
        sortable: false
      },

      {
        name: 'type',
        text: 'Type',
        value: 'type',
        sortable: false
      },
      {
        name: 'qty',
        text: 'Qty',
        value: 'qty',
        sortable: false
      },
      {
        name: 'sku',
        text: 'Sku',
        value: 'sku',
        sortable: false
      },
      {
        name: 'version',
        text: 'Version',
        value: 'version',
        sortable: false
      },
      {
        name: 'tax_rate',
        text: 'Tax Rate',
        value: 'tax_rate',
        sortable: false
      },

      {
        name: "price",
        type: "currency",
        width: '120px',
        text: "Price",
        value: "price",
        sortable: false,
      },
      {
        name: "tax_value",
        type: "currency",
        width: '120px',
        text: "Tax",
        value: "tax_value",
        sortable: false,
      },
      {
        name: "total",
        type: "currency",
        width: '120px',
        text: "Total",
        value: "total",
        sortable: false,
      },
      {
        name: "total_calculated",
        type: "currency",
        width: '120px',
        text: "Total",
        value: "total",
        calc: (item: Package) => {
          const tot = Number(item.price) * Number(item.qty) * (100 - Number(item.discount_rate)) / 100;
          return tot + tot * Number(item.tax_rate) / 100;
        },
        sortable: false,
      },
      {
        name: "expiry",
        type: "datetime",
        text: "Expiry",
        value: "expiry",
        sortable: false,
      },
      {
        name: "available_from",
        type: "datetime",
        text: "Available From",
        value: "available_from",
        sortable: false,
      },
      {
        name: "created",
        type: "datetime",
        text: "Created",
        value: "created_at",
        sortable: false,
      },
      {
        name: "updated",
        type: "datetime",
        text: "Updated",
        value: "updated_at",
        sortable: false,
      },
      {
        name: "actions",
        type: "actions",
        text: "Actions",
        value: "updated_at",
        sortable: false,
        width: "1%"
      }
    ];
  }

  private actions = {
    // edit: {
    //   icon: 'edit',
    //   link: (v: Package) => {
    //     return `/order/${v.id}`;
    //   }
    // },
    // view: {
    //   icon: 'visibility',
    //   link: (v: Package) => {
    //     return;
    //   }
    // }
  };
  public async Data(req: DataReq) { // return dummy data for editor
    return [{
      id: 64,
      package_group_id: 4,
      code: "HDXMZAR099-100",
      account_code: null,
      title: "Dummy Package",
      description: "test",
      category: "software",
      currency: "ZAR",
      price: 1,
      is_plan: true,
      discount_class: null,
      interval: "month",
      discount_rate: 0,
      long_description: "test",
      type: "prepaid",
      sku: 99,
      version: 99,
      tax_rate: 14,
      tax_value: 0.14,
      total: 1.14,
      qty: 1,
      is_valid: true,
      is_public: true,
      expiry: "2018-10-11T22:00:00Z",
      available_from: null,
      created_at: "2017-10-11T00:12:22Z",
      updated_at: "2017-10-11T00:13:25Z",
      is_visible_now: null,
      is_visible_state: null
    }];
  }

  public Filter(v: Package) {
    return true;
  }

  public ValueStyle(header: any, value: any, item: any) {
    const style: any = {};
    if (header.colors) {
      style.color = header.colors[value] ? header.colors[value] : header.colors._ || "#000";
    }
    return style;
  }

  public ItemActions(v: Package) {
    const actions: any = [
      // this.actions.view
    ];

    const OActions: any = {
      // DRAFT: [this.actions.edit],
      // DECLINED: [this.actions.edit]
    };

    // if (v.state && OActions[v.state]) {
    //   actions.push(...OActions[v.state]);
    // }

    return actions;
  }

  public get DatasourceFilters() {
    return [{
      name: 'type',
      text: 'Type',
      required: false,
      type: 'multi',
      multiple: true,
      items: () => [
        { val: "prepaid", text: "Pre-paid" },
        { val: "postpaid", text: "Post-paid" }
      ],
      selectMultiple: false,
      value: (selected: any) => {
        if (!selected) { return null; }
        if (isArray(selected)) {
          if (!selected.length) { return null; }
          return selected;
        }
        return [selected];
      }
    },
    {
      name: 'category',
      text: 'Category',
      required: false,
      type: 'multi',
      multiple: true,
      items: () => [
        { val: "hardware", text: "Hardware" },
        { val: "software", text: "Software" },
        { val: "shipping", text: "Shipping" },
        { val: "coupon", text: "Counpon" },
      ],
      selectMultiple: false,
      value: (selected: any) => {
        if (!selected) { return null; }
        if (isArray(selected)) {
          if (!selected.length) { return null; }
          return selected;
        }
        return [selected];
      }
    },
    {
      name: 'interval',
      text: 'Interval',
      required: false,
      type: 'multi',
      multiple: true,
      items: () => [
        { val: "trial", text: "Trial" },
        { val: "once", text: "Once-Off" },
        { val: "month", text: "Monthly" },
        { val: "year", text: "Annual" }
      ],
      selectMultiple: false,
      value: (selected: any) => {
        if (!selected) { return null; }
        if (isArray(selected)) {
          if (!selected.length) { return null; }
          return selected;
        }
        return [selected];
      }
    }];
  }
}
